module.exports = __webpack_public_path__ + "static/media/bg_footer.2d138159.jpg";